#import '../fragment/settlement.graphql'

mutation acceptSettlement($id: ID!) {
  acceptSettlement(id: $id) {
    ...settlementFragment
  }
}
